export default __webpack_public_path__ + "static/media/hotei22.a0f6ebe6.webp";